module.exports = __webpack_public_path__ + "img/Dotkit-NewLayer.a2f8b438.jpg";